import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import Section from '../../../shared/Section/Section';
import styles from './styles';

const gridItemsReorder = (idx, length) => {
  const middle = Math.ceil(length / 2);
  return idx < middle ? idx * 2 : (idx - middle) * 2 + 1;
};

function PreCourseDetails({ details, title, subtitle, bg }) {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Section
      title={title}
      subtitle={subtitle}
      bg={bg}
      withoutBg={!bg}
      customStyles={{
        paddingBottom: {
          md: '40px !important',
          xs: '16px !important',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '32px',
          flexWrap: {
            xs: 'wrap',
            md: 'nowrap',
          },
        }}
      >
        {details.map((detail, index) => {
          const { Icon } = detail;
          return (
            <Box
              key={`${detail}${index}`}
              order={{
                xs: index,
                md: gridItemsReorder(index, details.length),
              }}
              sx={{
                width: '100%',
              }}
            >
              <Box
                sx={styles.itemGrid(
                  gridItemsReorder(index, details.length) % 2,
                )}
              >
                <Typography variant="desktopP2" component="p">
                  {detail.title}
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    gap: 1,
                    mt: 1,
                    alignItems: { xs: 'center' },
                  }}
                >
                  <Icon
                    title={detail.title}
                    sx={{
                      width: { xs: 24, md: 28 },
                      height: { xs: 24, md: 28 },
                      svg: {
                        width: '100%',
                        height: '100%',
                      },
                    }}
                  />
                  <Box sx={styles.titleContainer}>
                    <Typography
                      variant={isSm ? 'mobileH3' : 'desktopH3'}
                      color="kit.text.main"
                      sx={{
                        lineHeight: {
                          sm: '40px !important',
                        },
                      }}
                    >
                      {detail.info}
                    </Typography>

                    {detail.format && (
                      <Box sx={styles.softChip}>
                        <Typography
                          variant="desktopP3"
                          sx={{ fontSize: { xs: '11px', md: '14px' } }}
                        >{`<${detail.format}>`}</Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Section>
  );
}

export default PreCourseDetails;
